module.exports = __webpack_public_path__ + "media/images/operation_jobs/icon_washer-1bbf52710ee2e3daf15566f3aa41efa7.png";